<div
    class="{{ className || 'lg-dropdown' }} {{ _alignClass }}"
    [ngClass]="{
        'lg-dropdown--disabled': _isDropdownDisabled,
        'lg-dropdown--missing': !_assigned && !emptyAcceptable,
        'lg-dropdown--invalid': !isValid,
        'lg-dropdown--active': _active
    }"
    [attr.title]="_getTitle()"
    tabindex="{{ _allowFocus ? 0 : -1 }}"
    lgTableInputNavigator
    [lgMarkFocusOn]="markFocusOn"
>
    @if (_currentValueIcons && _currentValueIcons.length) {
        <div class="lg-dropdown__icons">
            @for (icon of _currentValueIcons; track icon.icon) {
                <lg-icon
                    [icon]="icon.icon"
                    [class]="icon.iconClass"
                    [inline]="true"
                    title="{{ icon.title }}"
                    [lgTooltip]="icon.styledTitle ?? null"
                    lgTooltipClass="lg-tooltip lg-tooltip--simple"
                    [clickable]="!!icon.clickable"
                    (click)="_multiIconClick($event, icon, current)"
                ></lg-icon>
            }
        </div>
    }
    <div
        class="lg-dropdown__text"
        [ngClass]="{ 'lg-dropdown__text--empty': !_assigned && emptyAcceptable }"
    >
        {{ textOverride || _currentValueName }}
    </div>
    @if (!_hideArrow) {
        <lg-icon icon="icon-arrow-down" class="lg-dropdown__arrow"></lg-icon>
    }
    @if (!_hideArrow) {
        <div style="width: 30px"></div>
    }
</div>
